<template>
  <div class="main-body">
    <div class="header">家庭床位护理记录</div>
    <div class="out">

      <div class="search2">

        <div style="float:right;">

          <el-select v-model="governmentCode" placeholder="请选择政府"
                     @change="govChange"
                     style="margin-right:10px">
            <el-option
                v-for="item in governmentValue"
                :key="item.governmentCode"
                :label="item.name"
                :value="item.governmentCode">
            </el-option>
          </el-select>

          <el-select v-model="institutionCode" placeholder="请选择机构">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-button size="mini" plain style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>

        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="th" border >

        <el-table-column prop="elderlyName" label="患者" width="200" fixed></el-table-column>

        <el-table-column prop="address" label="地址" width="150"></el-table-column>

        <el-table-column prop="nursingItemName" label="护理项目" width="150"></el-table-column>

        <el-table-column prop="status" label="护理状态">
          <template slot-scope="scope">
            <p v-if="scope.row.status==0">未开始</p>
            <p v-if="scope.row.status==1">待结束</p>
            <p v-if="scope.row.status==2">待评价</p>
            <p v-if="scope.row.status==3">已评价</p>
          </template>
        </el-table-column>

        <el-table-column prop="recordType" label="护理人">
          <template slot-scope="scope">
            <p v-if="scope.row.recordType=='mediciner'">{{scope.row.medicinerName}}(医生)</p>
            <p v-if="scope.row.recordType=='nurse'">{{scope.row.nurseName}}(护士)</p>
            <p v-if="scope.row.recordType=='nurseAide'">{{scope.row.nurseAideName}}(护工)</p>
          </template>
        </el-table-column>


        <el-table-column prop="createTime" label="创建时间">
          <template slot-scope="scope">
            <p>{{scope.row.createTime | timefilters }}</p>
          </template>
        </el-table-column>



        <!--        <el-table-column fixed="right" label="操作" width="200">-->
        <!--          <template slot-scope="scope">-->
        <!--            <el-button type="text" size="medium" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>-->
        <!--            <el-button type="text" size="medium" @click="handleEditStaff(scope.$index, scope.row)">后台账号</el-button>-->
        <!--          </template>-->
        <!--        </el-table-column>-->

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="pageSize"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";


export default {
  name: "Page",


  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "";
      } else {
        let d = new Date(val);   //val 为表格内取到的后台时间
        let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    }
  },

  data(){
    return{
      tableLoading:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,

      arr_ins:[],
      institutionCode: '',

      governmentValue: [],
      governmentCode: '',

    }
  },

  created(){
    this.getGovList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    getGovList(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Government/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.governmentValue=response.data.data;

              if(this.governmentValue.length>0){
                this.governmentCode = this.governmentValue[0].governmentCode;
                this.getIns();
                this.getList();
              }

            } else if (response.data.error == 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },

    govChange(val){
      this.governmentCode = val;

      this.arr_ins = [];
      this.institutionCode = '';
      this.getIns();
    },

    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListByGovCode2",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: this.governmentCode,
          type:2,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    getList(isSearch) {
      if(isSearch)this.currentPage=1

      this.tableLoading=true

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"NursingRecord/AdmPage",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: this.governmentCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          institutionCode:this.institutionCode,
        }
      }).then( (response)=> {
        this.tableLoading=false

        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }
      }).catch(function (error) {
        //this.tableLoading=false
        console.log(error);
      });
    },


  }
}
</script>

